<!-- eslint-disable -->
<template lang="pug">
    div(v-if="errorStatus === 403")
        | {{ $i18n.t('common.common_textInfo_pageNotAllowed') }}
    profile-preview(v-else-if="!isLoading && grade")
        template(slot="left")
            svg-icon.profile__avatar(name="list-inverse" height="80px" width="80px")
            .profile__name
                | {{ grade.name }}
            .profile__school
                svg-icon(name="university" :area-hidden="true" height="30" width="30")
                | {{ grade.school.name }}
            .profile__items
                .profile__box
                    .profile__send-message-container
                        cs-button.profile__send-message(
                            color="white",
                            :full-width="true",
                            @click="switchModal('message')"
                        )
                            | {{ $i18n.t('profiles.profiles_user_sendMessage') }}
                    .profile__item.profile__item--size
                        svg-icon.profile__icon.profile__icon--small(
                            v-if="grade.status === 'active'",
                            name="check",
                            height="18px",
                            width="14px"
                        )
                        svg-icon.profile__icon.profile__icon--small(
                            v-else
                            name="times"
                            size="small"
                        )
                        .profile__text
                            .profile__text--header {{ $i18n.t('profiles.profiles_profile_status') }}
                            div {{ statusString }}
                    .profile__item.profile__item--size(v-if="grade.location")
                        svg-icon.profile__icon(name="pin", size="large")
                        .profile__text
                            .profile__text--header {{ $i18n.t('profiles.profiles_grade_location') }}
                            div {{ grade.location.city }}, {{ grade.location.address }}
                    .profile__item.profile__item--size(v-if="this.grade.startDate !== null || this.grade.endDate !== null")
                        svg-icon.profile__icon(name="calendar-list", size="large")
                        .profile__text
                            .profile__text--header {{ $i18n.t('profiles.profiles_grade_classDate') }}
                            div {{ datesOfClasses }}
                    .profile__item.profile__item--size(v-if="grade.timetable[0].day !== null")
                        svg-icon.profile__icon(name="calendar-list", size="large")
                        .profile__text
                            .profile__text--header {{ $i18n.t('profiles.profiles_grade_classDays') }}
                            div(v-for="timetable in grade.timetable")
                                | {{ [timetable.day.toString(), "E"] | moment('dd') }}
                                | {{ timetable.time }}
        template(slot="right")
            .info__buttons(v-if="!areSchoolsBlocked && (grade.school.isBillingActive ? grade.school.account.status : true)")
                cs-button.info__button(
                    v-if="grade.status === 'active' && isEditable"
                    @click="$router.push({name: 'grade:edit', params: {id: grade.id}})"
                    color="green"
                    pattern="primary-outline"
                )
                    | {{ $i18n.t('profiles.profiles_profile_edit') }}
                cs-button.info__button(
                    @click="checkRestorePrice"
                    v-else-if="isEditable"
                    color="green"
                )
                    | {{ $i18n.t('profiles.profiles_profile_restore') }}
            .info__item(v-if="this.grade.startDate !== null || this.grade.endDate !== null")
                .info__item-header
                    |  {{ $i18n.t('profiles.profiles_user_closestClasses') }}
                hr.info__divider
                .lessons(v-if="nearestClasses && nearestClasses.length > 0")
                    template(v-for="lesson in nearestClasses")
                        .lesson
                            .lesson__info
                                .lesson__course
                                    | {{ lesson.course.name }}
                                .lesson__date
                                    | {{ lesson.date | moment('DD.MM.YYYY') }}, {{ lesson.time }}
                        hr.info__divider
                .lessons__empty(v-else)
                    | {{ $i18n.t('profiles.profiles_grade_noClasses') }}
            .info__item
                .info__item-header
                    | {{ $i18n.t('profiles.profiles_grade_teacher') }}
                    span.info__item-header--light {{ grade.teachers.length }}
                hr.info__divider
                .teachers(v-if="grade.teachers && grade.teachers.length > 0")
                    .row
                        .col-xs-12.col-md-6.teacher(v-for="teacher in grade.teachers")
                            small-user-preview(:displayed-user="teacher")
            .info__item
                .info__item-header
                    | {{ $i18n.t('profiles.profiles_grade_students') }}
                    span.info__item-header--light {{ grade.students.length }}
                hr.info__divider
                .students(v-if="grade.students && grade.students.length > 0")
                    .row
                        .col-xs-12.col-md-6.student(v-for="student in grade.students")
                            small-user-preview(:displayed-user="student")
                    .row
                        cs-button.students__button(
                            color="blue"
                            pattern="primary-outline"
                            @click="$router.push({name: 'user:list', params: {type: 'student'}, query: {schoolId: grade.schoolId, gradeId: grade.id}})"
                        )
                            svg-icon.button__icon(name="tablet", size="large")
                            | {{ $i18n.t('profiles.profiles_profile_openList') }}
        create-message-modal(
            v-if="showMessageModal"
            @close="switchModal('message')"
            @send="sendMessage"
            :receivers="users"
            :name="grade.name"
            :school-id="grade.schoolId"
            :grade-id="grade.id"
        )

        cs-modal(v-if="priceModal.show" is-blur @close="closePriceModal")
            .price-modal-text(
                v-html="$i18n.t('user.user_form_withdrawal_of_money', { payment: '<b>' + priceModal.price + ' ' + $i18n.tc('olympiads.olympiads_olympiadForm_rubles', priceModal.price) + '</b>' })"
            )
            .price-modal-buttons
                cs-button(color="orange" @click="closePriceModal")
                    | {{ $i18n.t('user.user_form_cancel') }}
                cs-button(@click="restoreGrade")
                    | {{ $i18n.t('user.user_form_confirm') }}
    cs-loader(v-else)
</template>

<script>
    /*eslint-disable*/
    import GradeApi from '../../api/grade';

    import TimetableMixin from '../../utils/user/timetable';
    import SendMessageMixin from '../../utils/communication/sendMessageMixin';
    import BillingBlockMixin from '../../utils/user/BillingBlockMixin';
    import RestoreUserMixin from '../../utils/user/RestoreUserMixin';

    import CreateMessageModal from '../../modals/CreateMessageModal.vue';

    import ProfilePreview from './ProfilePreview.vue'
    import SmallUserPreview from './default-elements/SmallUserPreview.vue'

    import _ from 'lodash';
    import {mapState} from 'vuex'

    export default {
        mixins: [TimetableMixin, SendMessageMixin, BillingBlockMixin, RestoreUserMixin],
        data() {
            return {
                isLoading: false,
                grade: null,
                showMessageModal: false,
                errorStatus: null,
                priceModal: {
                    show: false,
                    price: 0,
                },
            }
        },
        props: ['id'],
        mounted() {
            this.fetchData();
        },
        methods: {
            async checkRestorePrice() {
                if (!this.isRestoreUserAllowed('grade')) {
                    return;
                }
                const price = await GradeApi.getPriceForActivate(this.grade.id);
                this.priceModal.show = true;
                this.priceModal.price = price;
            },
            restoreGrade () {
                if (!this.isRestoreUserAllowed('grade')) {
                    return;
                }
                this.closePriceModal();
                if (this.grade.school.status === 'active') {
                    let grade = _.cloneDeep(this.grade);
                    grade.status = 'active';
                    GradeApi.update(grade.id, grade)
                    .then(() => {
                        this.grade.status = 'active';
                    });
                } else {
                    this.$toasted.error(this.$i18n.t('errors.school_archived_cant_restore_grade'));
                }
            },
            fetchData() {
                this.isLoading = true;
                GradeApi.show(this.id)
                .then((data) => {
                    this.grade = data;
                    this.events = data.routine;
                    this.isLoading = false;
                })
                .catch(err => {
                    this.errorStatus = err.status;
                    this.isLoading = false
                })
            },
            switchModal (name) {
                const showProperty = _.camelCase('show-' + name + '-modal');
                this[showProperty] = !this[showProperty];
            },
            closePriceModal() {
                this.priceModal.show = false;
                this.priceModal.price = 0;
            },
        },
        computed: {
            ...mapState({
                user: state => state.auth.user,
            }),
            users() {
                return this.grade.teachers.concat(this.grade.students).filter(user => user.id !== this.user.id);
            },
            isEditable () {
                return this.user.isSuperadmin
                    || this.user.isManagerOrSupport
                    || (this.user.type === 'admin' && this.user.schoolsIds.includes(this.grade.schoolId));
            },
            datesOfClasses () {
                return `${this.$moment(this.grade.startDate ).format('DD.MM.YYYY')} - ${this.$moment(this.grade.endDate).format('DD.MM.YYYY')}`
            },
            statusString () {
                return this.$i18n.t('profiles.profiles_profile_status' + _.capitalize(this.grade.status))
            },
        },
        components: {
            SmallUserPreview,
            ProfilePreview,
            CreateMessageModal
        }
    }
</script>

<style lang="scss" scoped>
    .profile__avatar {
        color: $x-color-white;
    }

    .profile__name {
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        color: $x-color-white;
        margin: 20px 0 10px;
        text-align: center;
    }

    .profile__school {
        font-size: 20px;
        color: $x-color-white;
        margin-bottom: 20px;
        .svg-icon {
            margin-right: 10px;
        }
    }

    .profile__items {
        width: 100%;
    }

    .profile__box {
        display: flex;
        flex-wrap: wrap;
        margin: 0 auto;

        max-width: 240px;
        @include media($md) {
            max-width: 100%;
        }
        @include media($xlg) {
            max-width: 240px;
        }
    }

    .profile__send-message-container {
        display: flex;
        justify-content: center;
        width: 100%;
    }

    .profile__send-message {
        max-width: 240px;
    }

    .profile__item {
        box-sizing: border-box;
        padding: 0;
        color: $x-color-white;
        display: flex;
        font-size: 18px;
        line-height: 24px;
        margin-top: 34px;
    }


    .profile__item--size {
        width: 100%;
        @include media($md) {
            width: 50%;
            &:nth-child(odd) {
                padding-right: 20px;
            }
        }
        @include media($xlg) {
            width: 100%;
        }
    }

    .profile__icon {
        padding-top: 5px;
        margin-right: 10px;
    }

    .profile__icon--small {
        margin-right: 16px;
    }

    .profile__text {
        display: flex;
        flex-direction: column;
    }

    .profile__text--header {
        font-weight: 500;
    }

    .profile__link {
        font-size: 18px;
        line-height: 26px;
        color: $x-color-white;
        text-decoration-line: underline;
    }

    .info__buttons {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        margin: 20px 0;
        @include media($lg) {
            margin: 0 0 20px;
            flex-direction: row;
            justify-content: flex-end;
        }
    }

    .info__button {
        margin-bottom: 10px;
        @include media($lg) {
            margin-left: 10px;
        }
    }

    .info__item {
        padding: 30px;
        box-sizing: border-box;
        background-color: $hsl-color-gray-98;
        border-radius: $border-radius-20;

        display: flex;
        flex-direction: column;
        justify-content: space-between;

        margin-bottom: 0;
        &:not(:last-child) {
            margin-bottom: 30px;
        }
    }

    .info__item-header {
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        display: flex;
        align-items: center;
    }

    .info__item-header--light {
        margin-left: 1rem;
        color: $hsl-color-gray-74;
    }

    .info__divider {
        border: 0;
        margin: 25px auto 0;
        background: $hsl-color-gray-74;
        height: 1px;
        width: 100%;
        &:last-child {
            display: none;
        }
    }

    .main-contact, .admin, .teacher, .student {
        display: flex;
        box-sizing: border-box;
        margin-top: 30px;
    }

    .course {
        display: flex;
        box-sizing: border-box;
        margin-top: 30px;
        &:nth-child(odd) {
            padding-right: 20px;
        }
    }

    .course__info, .lesson__info {
        font-size: 16px;
        line-height: 24px;
        color: $x-color-black;
    }

    .course__icon {
        color: $hsl-color-green-58;
        margin-right: 15px;
    }

    .course__name, .billing__link {
        color: $hsl-color-blue-56;
        text-decoration: underline;
        &:hover {
            color: $hsl-color-blue-56;
            text-decoration: none;
        }
    }

    .lessons__empty {
        margin-top: 30px;
    }

    .lesson {
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
        margin-top: 30px;
        &:not(:last-child) {
            margin-bottom: 30px;
        }
    }

    .students__button {
        font-weight: 500;
        font-size: 18px;
        line-height: 21px;
        display: flex;
        align-items: center;
        margin-top: 30px;
    }

    .angle__icon {
        margin-left: 10px;
        color: $hsl-color-blue-56;
    }

    .angle__icon--inverse {
        transform: rotate(0.5turn);
    }

    .price-modal-text {
        margin-top: 20px;
    }

    .price-modal-buttons {
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
        .cs-button {
          padding: 15px 20px;
          @include media($md) {
            padding: 15px 30px;
          }
        }
    }
</style>
